import { render } from "./MimamoriTargetListComponent.vue?vue&type=template&id=1638eccb&scoped=true"
import script from "./MimamoriTargetListComponent.vue?vue&type=script&lang=js"
export * from "./MimamoriTargetListComponent.vue?vue&type=script&lang=js"

import "./MimamoriTargetListComponent.vue?vue&type=style&index=0&id=1638eccb&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1638eccb"]])

export default __exports__